import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/i18n';
import { Shell } from '@app/shell/shell.service';
import { AuthenticationGuard } from '../auth/authentication.guard';
import { RoleGuard } from '../auth/role.guard';
import { ModulePermissionGuard } from '../auth/module-permission.guard';
import { SuperuserGuard } from '../auth/superuser.guard';
//import { AppDataSyncGuard } from '../auth/syncappdata.guard';

//import { HomeComponent } from './home.component';
import { MandatComponent } from '@app/mandat/mandat.component';
import { ReportsComponent } from './../reports/reports.component';
//import { Modul0StartComponent } from '../modul0-start/modul0-start.component';

import { DashboardComponent } from './../dashboard/dashboard.component';
import { AboutComponent } from '../about/about.component';
import { SettingsComponent } from '../settings/settings.component';
import { SuperuserComponent } from '../superuser/superuser.component';
import { HelpComponent } from '@app/help/help.component';
import { ImpressumComponent } from '@app/impressum/impressum.component';
import { DatenschutzComponent } from '@app/datenschutz/datenschutz.component';
import { SupportComponent } from '@app/support/support.component';
import { StammdatenComponent } from '@app/stammdaten/stammdaten.component';
import { DienstnehmerComponent } from '@app/dienstnehmer/dienstnehmer.component';

import { TransferComponent } from '@app/transfer/transfer.component';
import { BulkImportComponent } from '@app/transfer/bulk-import/bulk-import.component';
import { VSTVComponent } from '@app/vstv/vstv.component';
import { MandatEditComponent } from '../mandat_edit/mandat_edit.component';
import { TransferEditComponent } from '../transfer_edit/transfer_edit.component';
import { ZahlungsabgleichComponent } from '@app/zahlungsabgleich/zahlungsabgleich.component';
import { ZahlungEditComponent } from '../zahlung_edit/zahlung_edit.component';

const routes: Routes = [
  Shell.childRoutes([
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    {
      path: 'dashboard',
      canActivate: [AuthenticationGuard],
      component: DashboardComponent,
      data: { title: extract('Dashboard') },
    },
    {
      path: 'mandate',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: MandatComponent,
      data: { title: 'Mandate', module: 'mandate' },
      children: [
        {
          path: 'edit',
          canActivate: [AuthenticationGuard, SuperuserGuard],
          component: MandatEditComponent,
        },
      ],
    },

    {
      path: 'transfer',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: TransferComponent,
      data: { title: 'Transfer', module: 'transfer' },
      children: [
        {
          path: 'edit',
          canActivate: [AuthenticationGuard, SuperuserGuard],
          component: TransferEditComponent,
        },
      ],
    },

    {
      path: 'bulk-import',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: BulkImportComponent,
      data: { title: 'Bulk-Import', module: 'bulk-import' },
    },

    {
      path: 'vstv',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: VSTVComponent,
      data: { title: 'VSTV Export', module: 'vstv' },
    },

    {
      path: 'reports',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: ReportsComponent,
      data: { title: 'Reports', module: 'reports' },
    },

    {
      path: 'zahlungsabgleich',
      canActivate: [AuthenticationGuard, ModulePermissionGuard],
      component: ZahlungsabgleichComponent,
      data: { title: 'Zahlungsabgleich', module: 'zahlungsabgleich' },
      children: [
        {
          path: 'edit',
          canActivate: [AuthenticationGuard],
          component: ZahlungEditComponent,
        },
      ],
    },

    { path: 'about', canActivate: [AuthenticationGuard], component: AboutComponent, data: { title: extract('About') } },
    {
      path: 'settings',
      canActivate: [AuthenticationGuard, RoleGuard],
      component: SettingsComponent,
      data: { title: extract('Settings'), roles: [1, 2] },
    },
    {
      path: 'superuser',
      canActivate: [AuthenticationGuard, RoleGuard],
      component: SuperuserComponent,
      data: { title: extract('Superuser'), roles: [1] },
    },
    {
      path: 'stammdaten',
      canActivate: [AuthenticationGuard, RoleGuard],
      component: StammdatenComponent,
      data: { title: extract('Stammdaten'), roles: [1, 2] },
    },
    {
      path: 'dienstnehmer',
      canActivate: [AuthenticationGuard, RoleGuard],
      component: DienstnehmerComponent,
      data: { title: extract('Benutzer'), roles: [1] },
    },
    {
      path: 'datenschutz',
      canActivate: [],
      component: DatenschutzComponent,
      data: { title: extract('Datenschutz') },
    },
    {
      path: 'impressum',
      canActivate: [],
      component: ImpressumComponent,
      data: { title: extract('Impressum') },
    },
    { path: 'help', canActivate: [AuthenticationGuard], component: HelpComponent, data: { title: extract('Help') } },
    {
      path: 'support',
      canActivate: [AuthenticationGuard],
      component: SupportComponent,
      data: { title: extract('Support') },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ShellRoutingModule {}
